import { useLocSettings } from "../../hooks/SettingsHooks";
import { facetProducts } from "../../utils/ProductsUtils";
import ProductsFilter from "./ProductsFilter";
import { useCategory } from "../../hooks/ProductHooks";
import "./style.scss";

const ProductsFilters = ({
  categoryId,
  products,
  allProducts,
  activeFilters,
  setFilter
}) => {
  const category = useCategory(categoryId);
  const settings = useLocSettings();
  const filterFields = category?.available_filters || [];
  const valueOrder = settings.specification_value_order;
  const hiddenSpecs = Array.isArray(settings?.hidden_specifications)
    ? settings.hidden_specifications
    : [];

  const filterData = {};
  filterFields.forEach(filterField => {
    if (!hiddenSpecs.includes(filterField)) {
      const allFacets = facetProducts(allProducts, filterField);
      const curFacets = facetProducts(products, filterField);
      const facets = {};
      Object.entries(allFacets)
        .sort(([a], [b]) =>
          valueOrder[filterField]
            ? valueOrder[filterField].indexOf(a) -
              valueOrder[filterField].indexOf(b)
            : a.localeCompare(b)
        )
        .forEach(([value, count]) => {
          facets[value] = { total: count };
        });
      Object.entries(curFacets).forEach(([value, count]) => {
        facets[value].filteredCount = count;
      });
      filterData[filterField] = facets;
    }
  });

  //console.debug("settings.specifications", settings.specifications);

  return (
    <div className={"filters"}>
      {Object.entries(filterData).map(([filterField, data]) => (
        <ProductsFilter
          filterField={filterField}
          data={data}
          activeFilters={activeFilters}
          setFilter={setFilter}
          key={filterField}
        />
      ))}
    </div>
  );
};

export default ProductsFilters;
